export default "/images/vendor/@coreui/icons/svg/flag/cif-bf.svg?a70fb553b0edc789e7b8aed2f7dddc19";